module.exports = __webpack_public_path__ + "img/20221028-active.41dc92a8.png";